import { StaticImage } from "gatsby-plugin-image";
import React from "react";

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  loading?: "eager" | "lazy";
}

// We optimize only the images that are served in the first page load
// we defer off-screen images
const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  className,
  style,
  loading = "lazy",
}) => {
  // StaticImage requires static src path at build time
  const imageSrc = src.startsWith("/") ? src : `/${src}`;
  switch (imageSrc) {
    case "/images/slider/1.jpg":
      return (
        <StaticImage
          src={"../../images/slider/1.jpg"}
          alt={alt}
          className={className}
          style={style}
          loading={loading}
        />
      );
    case "/images/rooms/pmr/1.jpg":
      return (
        <StaticImage
          src={"../../images/rooms/pmr/1.jpg"}
          alt={alt}
          className={className}
          style={style}
          loading={loading}
        />
      );
    case "/images/rooms/simple/1.jpg":
      return (
        <StaticImage
          src={"../../images/rooms/simple/1.jpg"}
          alt={alt}
          className={className}
          style={style}
          loading={loading}
        />
      );
    case "/images/rooms/superieure/1.jpg":
      return (
        <StaticImage
          src={"../../images/rooms/superieure/1.jpg"}
          alt={alt}
          className={className}
          style={style}
          loading={loading}
        />
      );
    case "/images/rooms/confort/1.jpg":
      return (
        <StaticImage
          src={"../../images/rooms/confort/1.jpg"}
          alt={alt}
          className={className}
          style={style}
          loading={loading}
        />
      );
    case "/images/rooms/prestige/1.jpg":
      return (
        <StaticImage
          src={"../../images/rooms/prestige/1.jpg"}
          alt={alt}
          className={className}
          style={style}
          loading={loading}
        />
      );
    case "/images/services/breakfast.jpg":
      return (
        <StaticImage
          src={"../../images/services/breakfast.jpg"}
          alt={alt}
          className={className}
          style={style}
          loading={loading}
        />
      );
    case "/images/services/park.jpg":
      return (
        <StaticImage
          src={"../../images/services/park.jpg"}
          alt={alt}
          className={className}
          style={style}
          loading={loading}
        />
      );
    default:
      return (
        <img
          loading={loading}
          src={imageSrc}
          alt={alt}
          className={className}
          style={style}
        />
      );
  }
};

export default OptimizedImage;
